import { FC } from 'react'
import { AISuggestionsToggler } from 'builder/components/AiFeatures/Suggestions'
import { AvailableAISuggestions } from 'builder/modules/resumeEditor'
import { SectionTitleBadgeProps } from 'builder/components/SectionTitle'

export const SkillsSuggestionsToggler: FC<SectionTitleBadgeProps> = props => {
  return <AISuggestionsToggler type={AvailableAISuggestions.skills} {...props} />
}
